import React, { useState } from "react";
import "../../../styles/dashboard/SuperAdmin/SystemConfig.css";

export default function SystemConfig({ role = "superadmin" }) {
  const [config, setConfig] = useState({
    minWalletBalance: 100,
    encryptionKey: "*********",
  });

  const handleChange = (e) => {
    setConfig({ ...config, [e.target.name]: e.target.value });
  };

  return (
    <div className="system-config">
      <h2>System Configuration</h2>
      <form>
        <label>
          Default Min Wallet Balance:
          <input
            type="number"
            name="minWalletBalance"
            value={config.minWalletBalance}
            onChange={handleChange}
          />
        </label>
        <label>
          Encryption Key:
          <input
            type="text"
            name="encryptionKey"
            value={config.encryptionKey}
            onChange={handleChange}
          />
        </label>
        <button type="submit">Save Config</button>
      </form>
    </div>
  );
}
